import React from 'react';

const MetricCard = ({ icon, label, value, subtitle, trend, status, action, onClick }) => {
  const statusColors = {
    green: { dot: 'bg-green-500' },
    yellow: { dot: 'bg-yellow-500' },
    red: { dot: 'bg-red-500' },
    blue: { dot: 'bg-blue-500' },
    default: { dot: 'bg-gray-600' }
  };

  const trendColors = {
    up: 'text-green-400',
    down: 'text-red-400',
    neutral: 'text-gray-400'
  };

  const getTrendColor = () => {
    if (!trend) return trendColors.neutral;
    if (trend.includes('↑')) return trendColors.up;
    if (trend.includes('↓')) return trendColors.down;
    return trendColors.neutral;
  };

  const statusColor = statusColors[status] || statusColors.default;

  // Check if icon is a React element (Lucide icon) or string (emoji)
  const renderIcon = () => {
    if (React.isValidElement(icon)) {
      return icon;
    }
    return <span className="text-sm">{icon}</span>;
  };

  return (
    <div 
      className={`bg-slate-800 rounded-lg p-2.5 ${onClick ? 'cursor-pointer hover:bg-slate-700' : ''} transition-colors relative`}
      onClick={onClick}
      style={{ minWidth: '135px', height: '85px' }}
    >
      {/* Status Dot - smaller */}
      {status && status !== 'default' && (
        <div className={`absolute top-1.5 right-1.5 w-1.5 h-1.5 rounded-full ${statusColor.dot}`} />
      )}
      
      {/* Header - icon + label */}
      <div className="flex items-center gap-1.5 mb-1">
        {renderIcon()}
        <span className="text-[10px] uppercase text-gray-400 font-semibold tracking-wide">{label}</span>
      </div>
      
      {/* Value - REDUCED SIZE */}
      <div className="text-lg font-bold text-white mb-0.5 leading-tight">
        {value}
      </div>
      
      {/* Subtitle */}
      {subtitle && (
        <div className="text-[10px] text-gray-400 leading-tight">
          {subtitle}
        </div>
      )}
      
      {/* Trend */}
      {trend && (
        <div className={`text-[10px] font-medium ${getTrendColor()} leading-tight`}>
          {trend}
        </div>
      )}
      
      {/* Action button */}
      {action && (
        <button className="text-[10px] text-blue-400 hover:text-blue-300 mt-0.5 font-medium">
          {action}
        </button>
      )}
    </div>
  );
};

export default MetricCard;
